module.exports = __webpack_public_path__ + "man-carrying-package.baa5e198785769bf9c68148ef14f1590.svg";